export const PLATFORM: string = 'web'
